var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"go-up"},[_c('transition',{attrs:{"name":"bounce"}},[(_vm.showBtn)?_c('button',{on:{"click":_vm.goUp}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.arrowUp)}})]):_vm._e()])],1)}
var staticRenderFns = []

export { render, staticRenderFns }